import Vue from 'vue'
import Router from 'vue-router'
import activationCode from '@/views/activationCode/index.vue'
import searchCode from '@/views/searchCode/index.vue'
import codeDetail from '@/views/codeDetail/index.vue'
import guarantee from '@/views/guarantee/index.vue'
import exchange from '@/views/exchange/index.vue'
import landingPage from '@/views/landingpage/index.vue'
import landingPage2 from '@/views/landingpage2/index.vue'
import scanCodePage from '@/views/scan_code_page.vue'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: '激活',
      component: activationCode
    },
    {
      path: '/searchCode',
      name: '查询激活码',
      component: searchCode
    },
    {
      path: '/codeDetail',
      name: '激活码详情',
      component: codeDetail
    },
    {
      path: '/guarantee',
      name: '保修',
      component: guarantee
    },
    {
      path: '/exchange',
      name: '换机',
      component: exchange
    },
    {
      path: '/landingpage',
      name: '京东服务+',
      component: landingPage
    },
    {
      path: '/landingpage2',
      name: '京东服务+',
      component: landingPage2
    }, {
      path: '/scanCodePage',
      name: '扫描',
      component: scanCodePage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js